// C:\Helpdesk\frontend\src\pages/PrivacyPolicy.js
import React from 'react';
import PolicyPage from '../components/PolicyPage';

const PrivacyPolicy = () => {
  return (
    <PolicyPage title="Privacy Policy" lastUpdated="July 1, 2025">
      <section>
        <h2>1. Information We Collect</h2>
        <p>We collect information to provide better services to all our users. The types of information we collect include:</p>
        <ul>
          <li><strong>Account Information:</strong> Name, email address, and other details you provide when registering.</li>
          <li><strong>Usage Data:</strong> Information about how you use our service, including ticket history and interactions.</li>
          <li><strong>Device Information:</strong> IP address, browser type, and operating system for security purposes.</li>
        </ul>
      </section>

      <section>
        <h2>2. How We Use Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Respond to your support tickets and requests</li>
          <li>Detect and prevent fraud and abuse</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section>
        <h2>3. Information Sharing</h2>
        <p>We do not share personal information with companies, organizations, or individuals outside of YPS Helpdesk System except in the following cases:</p>
        <ul>
          <li>With your consent</li>
          <li>For external processing by our trusted service providers</li>
          <li>For legal reasons</li>
        </ul>
      </section>

      <section>
        <h2>4. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access, correct, or delete your personal information</li>
          <li>Object to processing of your personal data</li>
          <li>Request restriction of processing your personal data</li>
          <li>Request data portability</li>
        </ul>
      </section>

      <section>
        <h2>5. Contact Us</h2>
        <p>For any questions about this Privacy Policy, please contact us at <a href="keith@yps.com.my">keith@yps.com.my</a>.</p>
      </section>
    </PolicyPage>
  );
};

export default PrivacyPolicy;